export interface IMenuItem {
  name: string;
  path?: string;
  children?: Array<IMenuItem>;
  icon: string;
}

export const MENU: IMenuItem[] = [
  {
    name: "대시보드",
    icon: "mdiApps",
    path: "/",
  },
  {
    name: "토너먼트(게임)",
    icon: "mdiMessageBulleted",
    children: [
      {
        name: "토너먼트(게임)",
        path: "/tournament",
        icon: "",
      },
      {
        name: "전체 쪽지",
        path: "/social",
        icon: "",
      },
      {
        name: "클럽",
        path: "/club",
        icon: "",
      },
      {
        name: "클럽 개설",
        path: "/club-create",
        icon: "",
      },
      {
        name: "토너먼트(게임) 랭킹",
        path: "/tournamentRanking",
        icon: "",
      },
      {
        name: "유저 GP 보유 현황",
        path: "/user-game-point",
        icon: "",
      },
      {
        name: "게임 점검 일정",
        path: "/game-inspection-schedule",
        icon: "",
      },
      {
        name: "토너먼트(관리)",
        path: "/tournamentAdmin",
        icon: "mdiStar",
      },
      {
        name: "입장 설정 및 친구 보상",
        path: "/gameSetting",
        icon: "mdiNintendoGameBoy",
      },
      {
        name: "게임 밴 관리",
        path: "/game-ban",
        icon: "",
      },
    ],
  },
  {
    name: "GP 수동 지급",
    icon: "mdiMessageBulleted",
    children: [
      {
        name: "GP 수동 지급",
        path: "/manual-gp-payment",
        icon: "",
      },
      {
        name: "수동 지급 로그",
        path: "/manual-gp-payment-log",
        icon: "",
      },
    ],
  },
  {
    name: "공지",
    icon: "mdiMaterialUi",
    children: [
      {
        name: "이미지 팝업",
        path: "/image-popup",
        icon: "",
      },
      {
        name: "공지사항",
        path: "/notice",
        icon: "",
      },
      {
        name: "자주하는 질문",
        path: "/faq",
        icon: "",
      },
    ],
  },
  {
    name: "펍",
    icon: "mdiMapMarkerStar",
    path: "/cafe",
  },
  {
    name: "출석 보상",
    icon: "mdiNewspaper",
    children: [
      {
        name: "출석 테이블",
        path: "/attendance-table",
        icon: "",
      },
      {
        name: "출석 보상 설정",
        path: "/attendance-reward",
        icon: "",
      },
      {
        name: "출석 현황",
        path: "/attendance-history",
        icon: "",
      },
    ],
  },
  {
    name: "사용자",
    path: "/user",
    icon: "mdiAccountCard",
  },
  {
    name: "쿠폰함",
    icon: "mdiApps",
    path: "/coupon",
  },
  {
    name: "게임 쿠폰",
    icon: "mdiApps",
    children: [
      {
        name: "게임 쿠폰 발행",
        path: "/game-coupon",
        icon: "",
      },
      {
        name: "게임 쿠폰 리스트",
        path: "/game-coupon-list",
        icon: "",
      },
    ],
  },
  {
    name: "토너먼트 소식",
    icon: "mdiNewspaper",
    children: [
      {
        name: "본사 대회",
        path: "/runnerCompetition",
        icon: "",
      },
      {
        name: "대회 갤러리",
        path: "/gallery",
        icon: "",
      },
    ],
  },
  {
    name: "러튜브",
    icon: "mdiYoutube",
    children: [
      {
        name: "러너 영상",
        path: "/youtube",
        icon: "mdiYoutube",
      },
      {
        name: "유튜브 채널",
        path: "/youtube-channel",
        icon: "mdiYoutube",
      },
    ],
  },
  {
    name: "셀러 광고 관리",
    path: "/tournament-ad-video",
    icon: "mdiAdvertisements",
  },
  {
    name: "광고 관리",
    path: "/advertisement",
    icon: "mdiAdvertisements",
  },
  {
    name: "업데이트",
    path: "/appUpdate",
    icon: "mdiCloudDownload",
  },
  {
    name: "레퍼럴(영업용)",
    path: "/referralSales",
    icon: "mdiAccountCard",
  },
];
